import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Staff } from '@app/models/staff.model';
import { User } from '@app/models/user.model';

@Component({
  selector: 'app-search-select-field',
  templateUrl: './search-select-field.component.html',
})
export class SearchSelectFieldComponent {
  @Input() label!: string;
  @Input() userList?: User[];
  @Input() staffList?: Staff[];
  @Input() placeholder: string = '選択して下さい';
  @Input() clear?: boolean;
  @Output() userChange = new EventEmitter<User>();
  @Output() staffChange = new EventEmitter<Staff | null>();

  required: boolean = false;

  private _form!: FormControl;
  @Input()
  get form(): FormControl {
    return this._form;
  }
  set form(form: FormControl) {
    this._form = form;
    this.required = form.hasValidator(Validators.required);
  }
}
